import axios from 'axios'

export const getAuditLogs = params => axios.get('/api/v1/admin/audit-logs', { params })
export const getAuditLogDetail = id => axios.get('/api/v1/admin/audit-logs/detail', { params: { id } })
export const getAuditStatistics = params => axios.get('/api/v1/admin/audit-logs/statistics', { params })
